/* Series merchandising and complete front/rear vehicle matching. */
(async function () {
  const root = document.querySelector('[data-series]'), C = window.BDFitCore;
  if (!root || !C) return;
  const series = root.dataset.series, params = new URLSearchParams(location.search);
  root.querySelectorAll('[data-series-link]').forEach(a => {
    const url = new URL(a.href);
    params.forEach((v, k) => { if (k === 'buy' || k.startsWith('utm_') || ['make','model','year','trim','preview_theme_id'].includes(k)) url.searchParams.set(k, v); });
    a.href = url.pathname + url.search + url.hash;
  });
  const cfg = JSON.parse(root.querySelector('[data-series-config]').textContent);
  const grid = root.querySelector('[data-product-grid]'), cards = [...grid.querySelectorAll('.set-card')];
  const more = root.querySelector('[data-more-wheels]'), wheelStatus = root.querySelector('[data-wheel-status]');
  const wheelStatusText = root.querySelector('[data-wheel-status-text]'), noWheelQuote = root.querySelector('[data-no-wheel-quote]');
  const generation = root.querySelector('[data-corvette-generation]'), model = root.querySelector('[data-corvette-model]');
  // Eric's series recommendations. A selected year/trim also passes the axle checks below.
  const generations = {
    C5: ['Coupe','Convertible','Z06'],
    C6: ['Coupe','Convertible','Z06','ZR1','Grand Sport'],
    C7: ['Stingray','Stingray Z51','Z06','ZR1','Grand Sport'],
    C8: ['Stingray','Stingray Z51','E-Ray','Z06','ZR1','ZR1X','Grand Sport']
  };
  const forgedOnly = {C7: ['Stingray','Stingray Z51'], C8: ['E-Ray','Z06','ZR1','ZR1X','Grand Sport']};
  let vehicle = root._seriesVehicle || null, catalog = null, expanded = false;
  if (series === 'corvette') {
    const order = ['bd-f7','bd-f8','bd-f20','bd-f25','bd-f18','bd-f29','bd-f12','frc-5','frc-1','frc-25','frc-10','frc-11','frc-1l','frcx-25'];
    cards.sort((a,b) => { const ai=order.indexOf(a.dataset.productHandle), bi=order.indexOf(b.dataset.productHandle); return (ai<0?999:ai)-(bi<0?999:bi); });
    cards.forEach(c => grid.append(c));
  }
  function fillModels(value = '') {
    model.replaceChildren(new Option('All models',''));
    (generations[generation.value] || []).forEach(m => model.add(new Option(m,m)));
    model.disabled = !generation.value;
    if ([...model.options].some(o => o.value === value)) model.value = value;
  }
  function fromVehicle(saved) {
    if (!generation || !saved || saved.slugs.model !== 'corvette') return;
    const year = Number(saved.slugs.year), gen = year>=2020?'C8':year>=2014?'C7':year>=2005?'C6':year>=1997?'C5':'';
    const trim = saved.trim || '', name = /ZR1X/i.test(trim)?'ZR1X':/ZR1/i.test(trim)?'ZR1':/Z06/i.test(trim)?'Z06':/E[- ]?Ray/i.test(trim)?'E-Ray':/Grand.?Sport/i.test(trim)?'Grand Sport':/Z51/i.test(trim)?'Stingray Z51':/Stingray/i.test(trim)?'Stingray':'';
    generation.value = gen; fillModels(name);
  }
  function renderWheels() {
    let visible = [];
    for (const card of cards) {
      const forged = card.dataset.forgedCorvette === 'true';
      let show = !(generation && forgedOnly[generation.value]?.includes(model.value) && !forged);
      if (show && vehicle && catalog) {
        const product = catalog.products.find(p => p.handle === card.dataset.productHandle);
        if (product) show = C.gradeDesign(product, vehicle.vehicle, catalog.parts).verdict !== 'no';
      }
      if (show) visible.push(card);
      card.hidden = true;
    }
    visible.slice(0, expanded ? visible.length : 8).forEach(c => c.hidden = false);
    more.hidden = expanded || visible.length <= 8;
    const studio = root.querySelector('.series-studio');
    if (studio) studio.hidden = !!vehicle && !visible.some(c => c.dataset.productHandle === 'bd-f25') || !!generation && !!forgedOnly[generation.value]?.includes(model.value);
    noWheelQuote.hidden = !!visible.length;
    wheelStatusText.textContent = !visible.length ? 'No complete front and rear combination is listed for this selection.' : vehicle ? (catalog ? visible.length + ' designs with front and rear options for ' + vehicle.vehicle.label + '.' : 'Checking front and rear options…') : '';
    wheelStatus.hidden = !wheelStatusText.textContent;
    // The stock shelf follows the same series/vehicle selection as the main grid.
    root.querySelectorAll('[data-stock-grid] .set-card').forEach(c => c.hidden = !visible.some(v => v.dataset.productHandle === c.dataset.productHandle));
  }
  more.onclick = () => { expanded = true; renderWheels(); };
  if (generation) {
    generation.onchange = () => { fillModels(); expanded=false; root.dispatchEvent(new CustomEvent('bd:clear-series-vehicle')); renderWheels(); };
    model.onchange = () => { expanded=false; root.dispatchEvent(new CustomEvent('bd:clear-series-vehicle')); renderWheels(); };
    fromVehicle(vehicle);
  }
  root.addEventListener('bd:series-vehicle', event => { vehicle=event.detail; expanded=false; fromVehicle(vehicle); renderWheels(); });
  renderWheels();
  try {
    const response = await fetch(cfg.fitdataUrl); if (!response.ok) throw Error('Unavailable');
    catalog = await response.json();
    if (series === 'corvette') {
      const stockGrid = root.querySelector('[data-stock-grid]');
      // Approved evergreen merchandising heading; exact configuration availability lives on each PDP.
      for (const card of cards.filter(c => c.dataset.forgedCorvette === 'true').slice(0,4)) {
        const clone=card.cloneNode(true); clone.hidden=false; stockGrid.append(clone);
      }
      root.querySelector('[data-stock-status]').textContent='Choose your sizes and finish on the wheel page, or contact our team to confirm your setup and shipping details.';
    }
    renderWheels();
  } catch (_) { if(vehicle) { wheelStatusText.textContent='Vehicle matching is unavailable. Confirm front and rear sizes with our team.'; wheelStatus.hidden=false; noWheelQuote.hidden=false; } }
  const gallery = root.querySelector('[data-gallery]'), status=root.querySelector('[data-gallery-status]');
  const load=root.querySelector('[data-more-gallery]'), make=root.querySelector('[data-make]');
  let builds=[], limit=6;
  function renderGallery() {
    const selected=builds.filter(g=>!make?.value||g.mk===make.value); gallery.replaceChildren();
    selected.slice(0,limit).forEach(g=>{
      const a=document.createElement('a'); a.href='/pages/car-gallery/'+g.h;
      const img=document.createElement('img'); img.src=g.i; img.alt=g.t+' / '+g.d; img.loading='lazy'; img.width=800; img.height=534;
      const h=document.createElement('h3'); h.textContent=g.t;
      const p=document.createElement('p'); p.textContent=g.d+' / '+g.f;
      a.append(img,h,p); gallery.append(a);
    });
    status.textContent=`Showing ${Math.min(limit,selected.length)} of ${selected.length} builds`; load.hidden=limit>=selected.length;
  }
  try {
    const response=await fetch(cfg.galleryUrl); if(!response.ok)throw Error();
    const data=await response.json();
    builds=data.cars.filter(g=>g.i&&(series==='offroad'?/^BD-O(?:102|728|801)$/i.test(g.d):series==='flow'?/Flow Forged/i.test(g.st):/corvette/i.test(g.t+' '+g.md))&&!['2026-c8-corvette-z06-c8-z06-wheels'].includes(g.h));
    if(series==='corvette') {
      const featured=builds.find(g=>g.h==='2025-chevy-corvette-c8-z06-with-bd-fr25');
      if(featured){builds=[featured,...builds.filter(g=>g!==featured)];}
    }
    if(make){[...new Set(builds.map(g=>g.mk))].sort().forEach(m=>make.add(new Option(m,m)));make.onchange=()=>{limit=6;renderGallery();};}
    load.onclick=()=>{limit+=6;renderGallery();};renderGallery();
  } catch (_) { status.textContent='Explore more builds in our vehicle gallery.'; const a=document.createElement('a');a.href='/pages/car-gallery';a.textContent='Browse all builds →';gallery.append(a); }
})();
